const revisions=new Map<number,number>();
const writes=new Map<number,Promise<void>>();
/** Serialize quick toggle changes so the durable task finishes with the latest choice. */
export function persistTaskInspire(projectId:number,enabled:boolean):Promise<void>{
 revisions.set(projectId,(revisions.get(projectId)??0)+1);
 const previous=writes.get(projectId)??Promise.resolve();
 const next=previous.catch(()=>{}).then(async()=>{
  const response=await fetch(`/api/canvas/projects/${projectId}/creative-mode`,{method:'PATCH',headers:{'Content-Type':'application/json'},body:JSON.stringify({creativeMode:enabled?'inspire':'brand-led'})});
  if(!response.ok)throw new Error('Could not save Inspire. Your current choice is kept on this browser; toggle again to retry.');
 });
 writes.set(projectId,next);void next.finally(()=>{if(writes.get(projectId)===next)writes.delete(projectId);}).catch(()=>{});
 return next;
}
export async function recoverTaskInspire(projectId:number,getValue:()=>boolean|undefined,setValue:(value:boolean)=>void,isCurrent:()=>boolean):Promise<void>{
 if(writes.has(projectId))return;
 const initialValue=getValue();
 const revision=revisions.get(projectId)??0;
 const response=await fetch(`/api/canvas/projects/${projectId}/creative-mode`);
 if(!response.ok)return;
 const data=await response.json();
 if(isCurrent()&&getValue()===initialValue&&(revisions.get(projectId)??0)===revision&&(data.creativeMode==='inspire'||data.creativeMode==='brand-led'))setValue(data.creativeMode==='inspire');
}
export function savedBriefMode(angles:any[]):'Inspire'|'Brand-led'|'Mixed modes'|'Mode not recorded'{
 const modes=Array.from(new Set(angles.map(angle=>angle.copyAssets?.adImage?.creativeMode)));
 if(!modes.length||modes.some(mode=>mode!=='inspire'&&mode!=='brand-led'))return 'Mode not recorded';
 return modes.length>1?'Mixed modes':modes[0]==='inspire'?'Inspire':'Brand-led';
}
